module.exports = __webpack_public_path__ + "static/4-927537f307cf484d1de26edcd60ed85e.jpg";